const SENSITIVE_VALUE_KEY = /token|jwt|secret|authorization/i;

export const hasValue = value => value !== undefined && value !== null && value !== '';

export function displayValue(value) {
	if (!hasValue(value)) return null;
	if (Array.isArray(value)) return value.filter(hasValue).join(' | ');
	if (typeof value === 'object') return JSON.stringify(value);
	return String(value);
}

export function copyText(value, onCopied) {
	if (!hasValue(value)) return;
	const text = String(value);
	const fallbackCopy = () => {
		const input = document.createElement('textarea');
		input.value = text;
		input.style.position = 'fixed';
		input.style.opacity = '0';
		document.body.appendChild(input);
		input.select();
		const copied = document.execCommand('copy');
		document.body.removeChild(input);
		if (copied && onCopied) onCopied();
	};

	if (navigator.clipboard && navigator.clipboard.writeText) {
		navigator.clipboard.writeText(text).then(() => onCopied && onCopied()).catch(fallbackCopy);
	} else {
		fallbackCopy();
	}
}

export function shortenSensitiveValues(value, showFull) {
	let foundLongValue = false;
	const visit = (current, key) => {
		if (current && typeof current === 'object') {
			if (Array.isArray(current)) return current.map(item => visit(item, ''));
			const result = {};
			Object.keys(current).forEach(childKey => {
				result[childKey] = visit(current[childKey], childKey);
			});
			return result;
		}
		if (typeof current === 'string' && SENSITIVE_VALUE_KEY.test(key) && current.length > 48) {
			foundLongValue = true;
			return showFull ? current : `${current.slice(0, 18)}...${current.slice(-8)}`;
		}
		return current;
	};
	return { value: visit(value, ''), foundLongValue };
}
